$(document).ready(function () {
  // イベントハンドラの登録
  var $doc = $(document);
  $doc.on("click", "#section-ceo-questions .questions-wrapper", onClickQuestion);

  // ビューポートの調整
  adjustViewport();
});

/**
 * タブレットでPC版の縮小表示をするビューポートを調整
 */
function adjustViewport() {
  let ua = navigator.userAgent.toLowerCase();
  let isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

  if (isMobile) {
    $("head").append('<meta name="viewport" content="width=device-width,initial-scale=1">');
  } else {
    $("head").append('<meta name="viewport" content="width=1400">');
  }
}

/**
 * よくあるご質問 開閉処理
 */
function onClickQuestion(e) {
  var $answer_obj = $(this).find(".answer");
  var $control_obj = $(this).find(".controller");
  if ($control_obj.hasClass("open")) {
    $control_obj.removeClass("open");
    $control_obj.addClass("close");
    $answer_obj.slideToggle();
  } else {
    $control_obj.removeClass("close");
    $control_obj.addClass("open");
    $answer_obj.slideToggle();
  }
}
